import { orderBy } from "natural-orderby";
import formatThousands from "format-thousands";
import { Modal } from "antd";
import moment from "moment";

export const getLocalStorageObject = (page) => {
  return JSON.parse(localStorage.getItem(page));
}
export const clearAllLocalStorageObject = (page) => {
  return localStorage.clear();
}
export const removeKeyLocalStorageObject = (page) => {
  return localStorage.removeItem(page);
}
export const setLocalStorageObject = (page, key, value, obj) => {
  obj[key] = value;
  localStorage.setItem(page, JSON.stringify(obj));
}

export const getCustomStrikeData = () => {
    return getLocalStorageObject("custom-strike") || {
      tblData: [],
      priceBasis: "Spot",
      isSyncStrikes: true,
      primaryCriteria: "Strike",
      primaryCeVal: "",
      primaryPeVal: "",
      primaryCeSign: "+",
      primaryCeType: "Multiplier",
      primaryPeSign: "+",
      primaryPeType: "Multiplier",
      hedgeCriteria: "Strike",
      hedgeCeVal: "",
      hedgePeVal: "",
      hedgeCeSign: "+",
      hedgeCeType: "Multiplier",
      hedgePeSign: "+",
      hedgePeType: "Multiplier"
    };
}

export const setCustomStrikeData = (data) => {
    localStorage.setItem("custom-strike", JSON.stringify(data));
}

export const isEmptyObject = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

export const isFunction = (functionToCheck) => {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
};

export const availableMaxContainerHeight = () => {
  const vh = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
  const menuBar = 70;
  const padding = 20;

  return vh - menuBar - padding;
};

export const sortPosition = (
  data,
  isClosedPosition
) => {
  try {
    const sortedPosition = orderBy(
      data,
      [
        v => v.netQuantity === 0,  
        v => v.instrument.name, 
        v => v.instrument.expiry,  
        v => v.instrument.strikePrice,  
        v => v.instrument.instrumentType
      ],
      ['asc', 'asc', 'asc', 'asc', 'asc']
    );
    return sortedPosition;
  } catch (err) {
    console.log(err);
  }
};
export const filterPosition = (
  data,
  isClosedPosition
) => {
  try {
    if(isClosedPosition) {
        const results = data.map((element) => {
          return {
          ...element,
          data: element.data.filter((item) =>
            item.netQuantity != 0
          ),
        };
      });
       return results.filter((item)=>item.data.length > 0);
    } else {
      return data;
    }
    
  
  } catch (err) {
    console.log(err);
  }
};
export const sortArray = (
  ticks,
  data,
  staticData,
  sortProperty,
  isAcending
) => {
  try {
    const sortDirection = isAcending ? "asc" : "desc";
    const d = ticks.map((tick) => {
      return {
        ...data[tick],
        tick: tick,
        name: staticData[tick]?.name,
      };
    });
    const sortedData = orderBy(d, [(v) => v[sortProperty]], [sortDirection]);

    return sortedData.map((data) => data.tick);
  } catch (err) {
    console.log(err);
  }
};

export const sorEODArray = (
  data,
  sortProperty,
  isAcending
) => {
  try {
    const sortDirection = isAcending ? "asc" : "desc";
    const sortedData = orderBy(data, [(v) => v[sortProperty]], [sortDirection]);
    return sortedData;
  } catch (err) {
    console.log(err);
  }
};

const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const getCredentialsFromCookie = () => {

  return getLocalStorageObject("user");
};

export const timeToLocal = (originalTime) => {
  const d = new Date(originalTime * 1000);
  return (
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds()
    ) / 1000
  );
};

export const convertUTCDateToLocalDate = (date) => {
  return new Date(date*1000).toISOString()
};

export const deleteCookieCredentials = () => {
  document.cookie = "loginSecret= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  document.cookie = "userID= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  sessionStorage.removeItem("fnotraderSecret");
  sessionStorage.removeItem("fnotraderUserid");
  try {
    localStorage.removeItem('user');
  } catch (e) {}

};

let isSessionExpiryHandling = false;
export const sessionExpireHandle = () => {
  if (isSessionExpiryHandling) return;
  isSessionExpiryHandling = true;
  try {
    deleteCookieCredentials();
  } catch (e) {}
  const path = window.location?.pathname || '';
  const isOnAuthRoute = path.startsWith('/authentication');
  if (isOnAuthRoute) {
    isSessionExpiryHandling = false;
    return;
  }
  Modal.warning({
    title: 'Session Expired',
    icon: null,
    content: 'Please log in again',
    okText: 'Login',
    onOk: () => {
      isSessionExpiryHandling = false;
      window.open('/authentication/login', '_self');
    },
  });
};

export const  deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}



export const getRandomColor = () => {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

function LightenDarkenColor(col, amt) {
  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

export const getvolumeData = (data, color) => {
  data.forEach(function(item) {
  if (item.cVal > item.oVal) {
    item.color = color[1];
  } else {
    item.color = color[0];
  }
});
return data;
} 

export const fmt = (val) => {
  return formatThousands(val, ",");
};

export const fmtINR = (val) => {

if(!val) {
   return 0.00
}
  return parseFloat(val).toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'INR'
    });
};
export const toDecimalNumber = (val, number) => {
  return val?.toFixed(number);
};

export const formatNumberToText = (number, type) => {
  if (typeof number !== 'number') {
    return NaN; // return NaN if the argument is not a number
  }

  const numberLength = number.toString().length;
  var divided = 0;
  var text = "";
  if(numberLength <= 5) {
    divided = 1000;
    text = "K";
  } else if(numberLength > 5 && numberLength <= 7) {
    divided = 100000;
    text = "L";
  } else if(numberLength > 7) {
    divided = 10000000;
    text = "Cr";
  }
   
  return (number / divided).toFixed(2) + text;
}

export const getDomainName = () => {

  var domain = window.location.host.split('.');
  var domainName = "";
  if(domain[0] == "www") {
     
    domainName = domain[1];
  } else {
    domainName = domain[0];
  }
  return domainName;
};





export const filteringStringFunction = (filteringArr, val, id) => {
  return filteringArr.filter((value) => {
 
    let fieldValue = value[id]
    return fieldValue?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  });
};

export const filteringNumbersFunction = (filteringArr, val, id) => {
 

  let operands = [">", "<", ">=", "<=", "="];
  let numbers = [];
  let operation = [];
  let charArr = val.trim().split("");
  for (var i = 0; i < charArr.length; i++) {
    if (operands.includes(charArr[i]) == false) {
      numbers.push(charArr[i]);
    } else {
      operation.push(charArr[i]);
    }
  }
  if (numbers && numbers.length > 0 && operation && operation.length > 0) {
    return checkNumberFiltering(
      filteringArr,
      parseFloat(numbers.join("")),
      operation.join(""),
      id
    );
  } else {
    return filteringArr;
  }
};

const checkNumberFiltering = (filteringArr, val, opr, id) => {
  return filteringArr.filter((token) => {
    let fieldValue = id === "packageEndTime"  ? moment(token[id]).diff(moment(), 'days') : token[id];
   
    if (fieldValue) {
      switch (opr) {
        case ">":
          return fieldValue > val;
        case "<":
          return fieldValue < val;
        case ">=":
          return fieldValue >= val;
        case "<=":
          return fieldValue <= val;
        case "=":
          return fieldValue == val;
      }
    }
  });
};


export const generateUniqueId = () => {
  return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
};

export const getChartBarsColor = (isDark) => {
  let colors;
  if(isDark) {
    colors = [
      "#863541",//red
      "#1a615b"//green
    ];
  } else {
    colors = [
      "#FBA8AF",//red
      "#90D5C9"//green
    ];
 }

  return colors;
};

export const calculateSLTP = (stopLossPrice, targetPrice, transactionType, lp, riskCoverType) => {
  var defSL = 0;
  
  if(stopLossPrice && stopLossPrice != 0) {
      if(transactionType==="BUY") {
        if (riskCoverType === 1) {
          defSL = parseFloat(lp) - (parseInt(stopLossPrice) / 100) * parseFloat(lp);
        } else if (riskCoverType === 2) {
          defSL = parseFloat(lp) - parseInt(stopLossPrice);
        }
      } else {
        if (riskCoverType === 1) {
          defSL = parseFloat(lp) + (parseInt(stopLossPrice) / 100) * parseFloat(lp);
        } else if (riskCoverType === 2) {
          defSL = parseFloat(lp) + parseInt(stopLossPrice);
        }
      }
  }
  var defTP = 0;
  if(targetPrice) {
    if(transactionType==="BUY") {
        if (riskCoverType === 1) {
          defTP = parseFloat(lp) + (parseInt(targetPrice) / 100) * parseFloat(lp);
        } else if (riskCoverType === 2) {
          defTP = parseFloat(lp) + parseInt(targetPrice);
        }
      } else {
        if (riskCoverType === 1) {
          defTP = parseFloat(lp) - (parseInt(targetPrice) / 100) * parseFloat(lp);
        } else if (riskCoverType === 2) {
          defTP = parseFloat(lp) - parseInt(targetPrice);
        }
      }
  }

  return {
    stopLossPrice:defSL == 0 ? null: defSL > 0 ? defSL.toFixed(2) : 0.05,
    targetPrice:defTP == 0 ? null : defTP > 0 ? defTP.toFixed(2) : 0.05
  }
};


export const calculatePrice = (lp, marketProtect, type, mode, marketBuffer) => {
    if (mode === "Limit at LTP") {
    return { price: parseFloat(lp) };
    }
  if (mode === "LIMIT" || mode === "SL") {
    return { price: (parseFloat(lp) + 0.05).toFixed(2) };
  }
  if (mode === "Limit with buffer") {
    var buffer = parseFloat(lp) * (parseInt(marketBuffer) / 100);
    var price = type === "BUY" ? parseFloat(lp) - buffer : parseFloat(lp) + buffer;
    price = type === "BUY" ? Math.ceil(price * 20) / 20 : Math.floor(price * 20) / 20;
    return { price: price };
  }
  var marketProtectprice = parseFloat(lp) * (parseInt(marketProtect) / 100);
  var price = type === "BUY" ? parseFloat(lp) + marketProtectprice : parseFloat(lp) - marketProtectprice;
  price = type === "BUY" ? Math.ceil(price * 20) / 20 : Math.floor(price * 20) / 20;
  return { price: price };
}


 export const  calculatePositionRealisedPnl = (position)  => {
  
    if(position.totalBuyQuantity === 0 || position.totalSellQuantity ===0) {
      return 0.00;
    } else {
      var minVal = Math.min(position.totalSellQuantity, position.totalBuyQuantity);
      var price = (position.sellAveragePrice-position.buyAveragePrice)*minVal;
      return price?.toFixed(2)
    }
  
  }

  export const calculatePositionUnrealisedPnl = (position, ltp) => {
    var qty = Math.abs(position.netQuantity);

  
    if(position.totalBuyQuantity > position.totalSellQuantity) {
      // long position
      return ((ltp - position.averagePrice) * qty)?.toFixed(2);
    } else if (position.totalSellQuantity > position.totalBuyQuantity) {
      // short position
      return ((position.averagePrice-ltp) * qty)?.toFixed(2)
    }
  
    return 0.00
  }

  export const OrderStatus = (internalStatus) => {
     if(internalStatus == "1" || internalStatus == "2"){
        return "Pending";
     }
     if(internalStatus == "3"){
        return "Completed";
     }
     if(internalStatus == "4"){
        return "Failed";
     }
     if(internalStatus == "5"){
      return "Cancelled";
     }
     if(internalStatus == "6"){
      return "Rejected";
     }
  }
  export const findNearestValue = (data, value, name, opActiveTab) => {
    const keys = Object.keys(data);
    var closestValueCE = Infinity;
    var closestIndexCE = -1;
    var closestValuePE = Infinity;
    var closestIndexPE = -1;
    for (var i = 0; i < keys.length; ++i) {
 
       var diffCE = Math.abs(Math.abs(data[keys[i]][name+'CE']) - value);
       if (diffCE < closestValueCE) {
        closestValueCE = diffCE;
        closestIndexCE = i;
       }
       var diffPE = Math.abs(Math.abs(data[keys[i]][name+'PE']) - value);
       if (diffPE < closestValuePE) {
        closestValuePE = diffPE;
        closestIndexPE = i;
       }
    }

    if(closestIndexCE >= 0 && closestIndexPE >= 0) {
      var BGcolor = "#00d27a80";
      var textColor = "#ffff";
      if(opActiveTab == 2) {
        BGcolor = "#00d27a80";
        textColor = "#000"
      }  
      //addColorToDiv(keys[closestIndexCE]+'-'+[name+'CE'], keys[closestIndexPE]+'-'+[name+'PE'], BGcolor, textColor);  
      return {
        ce:data[keys[closestIndexCE]],
        pe:data[keys[closestIndexPE]]
      }
    }
   

}

export const findStrikeDistance = (data, value, strike, type, isStraddle, opActiveTab) => {
  
  const keys = Object.keys(data);
  let middleIndex = keys.indexOf(strike+"") || 1;
    if (middleIndex === -1) {
    middleIndex = 0;
  }
   if(middleIndex >= 0) {
    var ceStrike,peStrike;
    if(value > 0) {
       ceStrike = keys[middleIndex+value];
       peStrike = keys[middleIndex-value];
    } else {
       ceStrike = keys[middleIndex-Math.abs(value)];
       peStrike = keys[middleIndex+Math.abs(value)];
    }
    var BGcolor = "#00d27a80";
    var textColor = "#ffff";
    if(opActiveTab == 2) {
      BGcolor = "#00d27a80";
      textColor = "#ffff"
    }        
     if(isStraddle) {
        if(ceStrike && peStrike) {
          addColorToDiv(ceStrike+'-lpCE', peStrike+"-lpPE", BGcolor, textColor); 
        }
     } else {
        if(ceStrike && type==="ce") {
          addColorToDiv(ceStrike+'-lpCE', "", BGcolor, textColor); 
        } else if(peStrike && type==="pe"){
          addColorToDiv("", peStrike+"-lpPE",BGcolor, textColor); 
        }
     }
     
          
          return {
            ce:data[ceStrike],
            pe:data[peStrike]
          }
      }

}

export const findStrikeDistanceStrangle  = (data, value, strikeCE, strikePE) => {
  
  const keys = Object.keys(data);
  const middleIndexCE = keys.indexOf(strikeCE+"");
  const middleIndexPE = keys.indexOf(strikePE+"");

   if(middleIndexCE >= 0 &&  middleIndexPE >=0) {
    var ceStrike,peStrike;
    if(value > 0) {
       ceStrike = keys[middleIndexCE+value];
       peStrike = keys[middleIndexPE-value];
    } else {
       ceStrike = keys[middleIndexCE-Math.abs(value)];
       peStrike = keys[middleIndexPE+Math.abs(value)];
    }
     
        if(ceStrike && peStrike) {
          addColorToDiv(ceStrike+'-lpCE', peStrike+"-lpPE","#00d27a80"); 
        } 
     
          
          return {
            ce:data[ceStrike],
            pe:data[peStrike]
          }
      }

}


 
  

const addColorToDiv = (idCE, idPE, BGcolor, textColor)=>{

    if(document.getElementById(idCE)) {
      document.getElementById(idCE).style.setProperty("background", BGcolor, "important"); 
     // document.getElementById(idCE).style.setProperty("color", textColor, "important"); 
    }
    if(document.getElementById(idPE)) {
      document.getElementById(idPE).style.setProperty("background", BGcolor, "important"); 
    // document.getElementById(idPE).style.setProperty("color", textColor, "important"); 
    }
}
export const changeColorToDiv = (id, color)=>{
   if(document.getElementById(id)) {
      document.getElementById(id).style.setProperty("background", color,  "important"); 
      document.getElementById(id).style.setProperty("color", "#fff", "important"); 
     
  }
}
export const clearColor = (idCE, idPE)=>{
    if(document.getElementById(idCE)) {
       document.getElementById(idCE).style.background = ""; 
       document.getElementById(idCE).style.color = ""; 
     }
    
     if(document.getElementById(idPE)) {
        document.getElementById(idPE).style.background=""; 
        document.getElementById(idPE).style.color=""; 
    }
}

export const clearStrikeColor = (name, type)=>{
  if(document.getElementsByClassName(name+type)) {
       const length = document.getElementsByClassName(name+type.toUpperCase()).length;
       for(let i = 0; i < length; i++) {
          document.getElementsByClassName(name+type.toUpperCase())[i].style.background = ""; 
          document.getElementsByClassName(name+type.toUpperCase())[i].style.color = "#000000bd"; 
       }
  }
}

export const exitOrder = (order, type, inputValues) => {
   const param = [];
    for(let i = 0; i < order.length; i++){
      if((order[i].instrument.instrumentType === type || type === "ALL") && order[i].netQuantity != 0) {
        
            
            // var marketProtectprice = parseFloat(order[i].ltp)*(parseInt(inputValues.exitmarketProtect)/100);
            // var price = order[i].netQuantity > 0 ? parseFloat(order[i].ltp)-marketProtectprice : parseFloat(order[i].ltp)+marketProtectprice;
            // price = order.netQuantity > 0 ? Math.floor(price*20)/20 : Math.ceil(price*20)/20;
           
            var transactionType = "";
            if(order[i].netQuantity > 0) {
              transactionType = "SELL";
            } else if(order[i].netQuantity < 0 ) {
              transactionType = "BUY";
            } 

            const price = calculatePrice(
                 order[i].ltp,
                 inputValues.exitmarketProtect,
                transactionType,
                inputValues.exitOrderType,
                inputValues.exitmarketBuffer
              ) 

              
            const orderParam =   {
              exchange:  order[i].exchange,
              variety: "REGULAR",
              validity: "DAY",
              product: order[i].product,
              orderType: "LIMIT",
              transactionType: transactionType,
              quantity:  Math.abs(order[i].netQuantity),
              price:   (inputValues.exitOrderType === "LIMIT" || inputValues.exitOrderType === "LIMIT_LTP" || inputValues.exitOrderType === "LIMIT_BUFFER") ? parseFloat(price.price) : 0,
              exchangeToken: order[i].exchangeToken,
              disclosedQuantity: 0,
              stopLossPrice: null,
              targetPrice: null,
              trailReferencePoints: null,
              trailStepPoints: null
            
          };
          param.push(orderParam)
    
      
      }
    }
   return param;
 }


 export const getMiddleStrike = (optionData, price) => {
  let lastIteratePrice = 0;
  let strike = {};

  for (let i = 0; i < optionData.length; i++) {
    if (price < optionData[i]?.strikePrice) {
      const middle =
        lastIteratePrice + (optionData[i].strikePrice - lastIteratePrice) / 2;
      if (middle > price) {
        strike = { index: i - 1, middleStrike: lastIteratePrice };
      } else {
        strike = { index: i + 1, middleStrike: optionData[i].strikePrice };
      }
      break;
    }
    lastIteratePrice = optionData[i]?.strikePrice;
  }
  return strike;
};

export const getSymbolList = (optionData, index, selectStrikes) => {
  const start = Math.max(index - 1 - selectStrikes * 2, 0);
  const end = Math.min(index + selectStrikes * 2, optionData.length);
 
  let symbolList = [];
  let strikeList = new Set();
  let symbolsToStrikePrice = {};

  for (let i = start; i <= end; i++) {
    symbolList.push(optionData[i]?.instrumentToken);
    const obj = symbolsToStrikePrice[optionData[i]?.strikePrice] || {};
    obj[optionData[i]?.instrumentType] = optionData[i]?.instrumentToken;
    obj[optionData[i]?.instrumentType+'-tradingSymbol'] = optionData[i]?.tradingSymbol;
    obj['exchangeToken-'+optionData[i]?.instrumentType] = optionData[i]?.exchangeToken;
    obj['tradingSymbol-'+optionData[i]?.instrumentType] = optionData[i]?.tradingSymbol;
    obj['exchange-'+optionData[i]?.instrumentType] = optionData[i]?.exchange;
    obj['lotSize-'+optionData[i]?.instrumentType] = optionData[i]?.lotSize;
    obj['displayName-'+optionData[i]?.instrumentType] = optionData[i]?.displayName;
    symbolsToStrikePrice[optionData[i]?.strikePrice] = obj;
    strikeList.add(optionData[i]?.strikePrice);
  }
  return { symbolList, symbolsToStrikePrice, strikeList: [...strikeList] };
};


//Read Made
export const getBullish =  (optionData, key, middleStrike, info) => {
 
    let json = [];
    if(key === "buyCall") {
      optionData[middleStrike].cellType = "CE";
      optionData[middleStrike].transactionType = "BUY";
      optionData[middleStrike].quantity = info.lotSize;
      
      json.push(optionData[middleStrike]);
    }
    if(key === "sellPut") {
      optionData[middleStrike].cellType = "PE";
      optionData[middleStrike].transactionType = "SELL";
      optionData[middleStrike].quantity = info.lotSize;
      json.push(optionData[middleStrike]);
    }
    if(key === "buyCallSpread") {
      optionData[middleStrike].cellType = "CE";
      optionData[middleStrike].transactionType = "BUY";
      optionData[middleStrike].quantity = info.lotSize;
      json.push(optionData[middleStrike]);
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+4;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
      }
    }
    if(key === "buyPutSpread") {
      optionData[middleStrike].cellType = "PE";
      optionData[middleStrike].transactionType = "SELL";
      optionData[middleStrike].quantity = info.lotSize;
      json.push(optionData[middleStrike]);
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex-4;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
      }
    }

    if(key === "buyCallRatioBackSpread") {
      optionData[middleStrike].cellType = "CE";
      optionData[middleStrike].transactionType = "SELL";
      optionData[middleStrike].quantity = info.lotSize;
      json.push(optionData[middleStrike]);
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+4;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
      }
    }
    if(key === "longCalendarwithCalls") {
      // optionData[middleStrike].cellType = "CE";
      // optionData[middleStrike].transactionType = "SELL";
      // optionData[middleStrike].quantity = info.lotSize;
      // json.push(optionData[middleStrike]);
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+5;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

        
      }
    }

    if(key === "bullCondor") {
     
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+5;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
        findIndex = findIndex + 4
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

        findIndex = findIndex + 4
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

        findIndex = findIndex + 4
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

        
      }
    }
    if(key === "bullButterfly") {
     
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+5;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
        findIndex = findIndex + 4
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

        findIndex = findIndex + 4
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

       

        
      }
    }
    if(key === "rangeForward") {
     
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+4;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }
        findIndex = findIndex - 8
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

         

       

        
      }
    }
    if(key === "longSyntheticFuture") {
        var objCE = {
          ...optionData[middleStrike],
         "cellType": "CE",
          "transactionType":"BUY",
          "quantity":info.lotSize
       };
       json.push(objCE)
        var objPE = {
         ...optionData[middleStrike],
         "cellType": "PE",
         "transactionType":"SELL",
         "quantity":info.lotSize
       };
       json.push(objPE)
    }
 
    return json;
    
}

export const getBearish =  (optionData, key, middleStrike, info) => {
  let json = [];
  if(key === "buyPut") {
    optionData[middleStrike].cellType = "PE";
    optionData[middleStrike].transactionType = "BUY";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);
  }
  if(key === "sellCall") {
    optionData[middleStrike].cellType = "CE";
    optionData[middleStrike].transactionType = "SELL";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);
  }
  if(key === "bearCallSpread") {
    optionData[middleStrike].cellType = "CE";
    optionData[middleStrike].transactionType = "SELL";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }
  if(key === "bearPutSpread") {
    optionData[middleStrike].cellType = "PE";
    optionData[middleStrike].transactionType = "BUY";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }

  if(key === "putRatioBackSpread") {
    optionData[middleStrike].cellType = "PE";
    optionData[middleStrike].transactionType = "SELL";
    optionData[middleStrike].quantity = info.lotSize;

    json.push(optionData[middleStrike]);
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }
  if(key === "longCalendarwithPuts") {
    
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-5;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }

  if(key === "bearCondor") {
   
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-5;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex - 4
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex - 4
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex - 4
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      
    }
  }
  if(key === "bearButterfly") {
   
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-5;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex - 4
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex - 4
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

     

      
    }
  }
  if(key === "riskReversal") {
   
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex - 8
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

       

     

      
    }
  }
  if(key === "shortSyntheticFuture") {
      var objCE = {
        ...optionData[middleStrike],
       "cellType": "CE",
        "transactionType":"SELL",
        "quantity":info.lotSize
     };
     json.push(objCE)
      var objPE = {
       ...optionData[middleStrike],
       "cellType": "PE",
       "transactionType":"BUY",
       "quantity":info.lotSize
     };
     json.push(objPE)
  }
 
  return json;
  
}

export const getNeutral =  (optionData, key, middleStrike, info) => {
  let json = [];
  if(key === "shortStraddle") {
     
      var objPE = {
      ...optionData[middleStrike],
      "cellType": "PE",
      "transactionType":"SELL",
      "quantity":info.lotSize
    };
    json.push(objPE);

    var objCE = {
      ...optionData[middleStrike],
      "cellType": "CE",
      "transactionType":"SELL",
      "quantity":info.lotSize
  };
  json.push(objCE)
  }
  if(key === "ironButterfly") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      var objPE = {
        ...optionData[middleStrike],
        "cellType": "PE",
        "transactionType":"SELL",
        "quantity":info.lotSize
      };
      json.push(objPE);
  
      var objCE = {
        ...optionData[middleStrike],
        "cellType": "CE",
        "transactionType":"SELL",
        "quantity":info.lotSize
    };
    json.push(objCE)
    findIndex = findIndex+8;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    }
  }
  if(key === "shortStrangle") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      let targetIndex = findIndex + 4;
      let strikeKey = Object.keys(optionData)[targetIndex];
      if(strikeKey && optionData[strikeKey]) {
        let strikeObj = optionData[strikeKey];
        
        json.push({
          ...strikeObj,
          cellType: "PE",
          transactionType: "SELL",
          quantity: info.lotSize
        });

        json.push({
          ...strikeObj,
          cellType: "CE",
          transactionType: "SELL",
          quantity: info.lotSize
        });
      }
    }
  }
  
  if(key === "shortIronCondor") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-8;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

    
    findIndex = findIndex+4;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    findIndex = findIndex+8;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    findIndex = findIndex+4;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    }
  }

  if(key === "batman") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex+5;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

    
    findIndex = findIndex+1;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    findIndex = findIndex-11;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    findIndex = findIndex-1;
    if(optionData[Object.keys(optionData)[findIndex]]) {
      optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
      optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
      optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
      json.push(optionData[Object.keys(optionData)[findIndex]]);
    }

    }
  }
  if(key === "doublePlateau") {
      let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
      if(findIndex >= 0) {
        findIndex = findIndex+4;
        if(optionData[Object.keys(optionData)[findIndex]]) {
          optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
          optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
          optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
          json.push(optionData[Object.keys(optionData)[findIndex]]);
        }

      
      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }


      // //pe

      findIndex = findIndex-21;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;

        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
     
  }

  if(key === "jadeLizard") {
   
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex + 14
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex + 3
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

     

      
    }
  }
  if(key === "reverseJadeLizard") {
   
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
      findIndex = findIndex - 14
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex - 3
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

    }

  }
  
 
  return json;
  
}

export const getOthers =  (optionData, key, middleStrike, info) => {
  let json = [];
  if(key === "callRatioSpread") {
    optionData[middleStrike].cellType = "CE";
    optionData[middleStrike].transactionType = "BUY";
    optionData[middleStrike].quantity = info.lotSize;

    json.push(optionData[middleStrike]);

    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex+4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }
  if(key === "putRatioSpread") {
    optionData[middleStrike].cellType = "PE";
    optionData[middleStrike].transactionType = "BUY";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);

    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize*2;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }
  if(key === "longStraddle") {
    var objPE = {
      ...optionData[middleStrike],
      "cellType": "PE",
      "transactionType":"BUY",
      "quantity":info.lotSize
    };
    json.push(objPE)

    var objCE = {
      ...optionData[middleStrike],
     "cellType": "CE",
      "transactionType":"BUY",
      "quantity":info.lotSize
   };
   json.push(objCE)
   
  }
  if(key === "longIronButterfly") {

    var objPE = {
      ...optionData[middleStrike],
      "cellType": "PE",
      "transactionType":"BUY",
      "quantity":info.lotSize
    };
    json.push(objPE)


    optionData[middleStrike].cellType = "PE";
    optionData[middleStrike].transactionType = "BUY";
    optionData[middleStrike].quantity = info.lotSize;
    json.push(optionData[middleStrike]);
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex+8;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }

    var objCE = {
      ...optionData[middleStrike],
     "cellType": "CE",
      "transactionType":"BUY",
      "quantity":info.lotSize
   };
   json.push(objCE)
  }

  if(key === "longStrangle") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {
      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex+8;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }
  if(key === "longIronCondor") {
    let findIndex = Object.keys(optionData).indexOf(middleStrike+'');
    if(findIndex >= 0) {

      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "PE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

     

      
      findIndex = findIndex+16;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "SELL";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }

      findIndex = findIndex-4;
      if(optionData[Object.keys(optionData)[findIndex]]) {
        optionData[Object.keys(optionData)[findIndex]].cellType = "CE";
        optionData[Object.keys(optionData)[findIndex]].transactionType = "BUY";
        optionData[Object.keys(optionData)[findIndex]].quantity = info.lotSize;
        json.push(optionData[Object.keys(optionData)[findIndex]]);
      }
    }
  }

  if(key === "strip") {
   
    var objPE = {
      ...optionData[middleStrike],
      "cellType": "PE",
      "transactionType":"BUY",
      "quantity":info.lotSize
    };
    json.push(objPE)

    var objCE = {
      ...optionData[middleStrike],
     "cellType": "CE",
      "transactionType":"BUY",
      "quantity":info.lotSize*2
   };
   json.push(objCE)
  }
  if(key === "strap") {
   
    var objPE = {
      ...optionData[middleStrike],
      "cellType": "CE",
      "transactionType":"BUY",
      "quantity":info.lotSize
    };
    json.push(objPE)

    var objCE = {
      ...optionData[middleStrike],
     "cellType": "PE",
      "transactionType":"BUY",
      "quantity":info.lotSize*2
   };
   json.push(objCE)
  }
 

  return json;
  
}


export const getZoomPrc = (optionData, price) => {

  var screenWidth = window.screen.width;
  var windowWidth = window.innerWidth;

  if(windowWidth != screenWidth){

      var zoomOutPoints = [25,33,50,67,75,80,90];
      var zoomInPoints = [110,125,150,175];
      var percentDifference = Math.ceil(( screenWidth / windowWidth) * 100);
      return percentDifference;
  }
}

export const isEntrantsList = (list, instrument) => {
  if (!list) return [];
  return list.filter((item)=>item.nseSymbol === instrument);
}

export const isBanList = (list, instrument) => {
  if (!list) return [];
  return list.filter((item)=>item.nseSymbol === instrument);
}

export const isExitList = (list, instrument) => {
  return list?.filter((item)=>item.nseSymbol === instrument);
}

export const isProPlan = (info, suscriptionStatus) => {
  if(info.selectedBroker === "papertrading"){
    return true;
  }

  if(suscriptionStatus?.proPlan?.length > 0){
    return true;
  }

  if(suscriptionStatus?.trial?.length > 0){
    return true;
  }

  return false;
 }

 export const setCookieCredentials = (data, localStorageObj) => {
  removeKeyLocalStorageObject("user");


  setLocalStorageObject('user', 'userID', data.userID, localStorageObj);
  setLocalStorageObject('user', 'userType', data.userType, localStorageObj);
  setLocalStorageObject('user', 'email', data.email, localStorageObj);
  setLocalStorageObject('user', 'loginSecret', data.loginSecret, localStorageObj);
  setLocalStorageObject('user', 'activeSubscription', data.activeSubscription, localStorageObj);
  setLocalStorageObject('user', 'activeTradeSubscription', data.activeTradeSubscription, localStorageObj);

  setLocalStorageObject('user', 'gUserRegisterRequired', data.gUserRegisterRequired, localStorageObj);
  setLocalStorageObject('user', 'subscriptionValidTill', data.subscriptionValidTill, localStorageObj);
  setLocalStorageObject('user', 'trialAllowed', data.trialAllowed, localStorageObj);
  setLocalStorageObject('user', 'tradeTrailAllowed', data.tradeTrailAllowed, localStorageObj);
  setLocalStorageObject('user', 'webSocketChannel', data.webSocketChannel.id, localStorageObj);
  setLocalStorageObject('user', 'tradeSubscriptionValidTill', data.tradeSubscriptionValidTill, localStorageObj);
  setLocalStorageObject('user', 'src', data.src, localStorageObj);
  setLocalStorageObject('user', 'isLoggedIn', data.isLoggedIn, localStorageObj);

}

export const getYouTubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const getYouTubeThumbnail = (videoId) => {
  return `https://img.youtube.com/vi/${videoId}/0.jpg`;
};

export const getYouTubeTitle = async (videoId) => {
  try {
    const url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error("Failed to fetch video details");
    }

    const data = await response.json();
    return data.title;
  } catch (error) {
    console.error("Error fetching YouTube title:", error);
    return null;
  }
};